module.exports = __webpack_public_path__ + "static/img/banner_zxyp.e836090b.jpg";